import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';
import { initSentry, Sentry } from './lib/sentry';

// Initialize Sentry before any React tree renders so errors during the
// initial render are captured. No-op in local dev unless VITE_SENTRY_DSN
// is set.
initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-[var(--background)] px-6">
          <div className="max-w-md w-full text-center space-y-4">
            <h1 className="text-[22px] font-semibold text-[var(--foreground)]">
              Something went wrong
            </h1>
            <p className="text-[15px] text-[var(--muted-foreground)]">
              We've been notified and are looking into it. You can try again,
              or refresh the page.
            </p>
            <button
              type="button"
              onClick={resetError}
              className="inline-flex items-center justify-center h-10 px-4 rounded-md bg-[var(--brand)] text-white font-medium hover:opacity-90"
            >
              Try again
            </button>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
